import { render, staticRenderFns } from "./mfa-modal.vue?vue&type=template&id=1b7be140&scoped=true"
import script from "./mfa-modal.vue?vue&type=script&lang=js"
export * from "./mfa-modal.vue?vue&type=script&lang=js"
import style0 from "./mfa-modal.vue?vue&type=style&index=0&id=1b7be140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7be140",
  null
  
)

export default component.exports